"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGraphTokenFailedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "GetGraphTokenFailed";
const messageKey = "plugins.spfx.cannotGetGraphToken";
class GetGraphTokenFailedError extends teamsfx_api_1.SystemError {
    constructor() {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey),
        });
    }
}
exports.GetGraphTokenFailedError = GetGraphTokenFailedError;
//# sourceMappingURL=getGraphTokenFailedError.js.map